import type { TripOptionCar } from '$lib/components/itinerary/tripOptions';
import { usePersistentState } from './persistentState.svelte';

const CAR_STORAGE_KEY = 'carStorage';

type CarInfo = Pick<TripOptionCar, 'model' | 'maker' | 'isEv' | 'energy'>;

interface CarStorage {
	[carId: string]: CarInfo;
}

export function useCarStorage() {
	const carStorage = usePersistentState<CarStorage>(CAR_STORAGE_KEY, {}, { storageType: 'local' });

	return {
		carStorage,

		saveCarInfo: (carId: string, carInfo: CarInfo) => {
			if (!carId || !carInfo) {
				return;
			}

			carStorage.setCurrent({
				...carStorage.getCurrent(),
				[carId]: carInfo,
			});
		},

		getCarInfo: (carId: string) => {
			if (!carId) {
				return;
			}

			return carStorage.getCurrent()[carId] ?? null;
		},
	};
}
